query BatchTransactionOptions {
  batchTransactions(
    orderBy: [DESCRIPTION_ASC, REFERENCE_NUMBER_ASC, PRIMARY_KEY_ASC]
    filter: {
      _accountingStampDate: { isNull: true }
      isDraft: { equalTo: true }
    }
  ) {
    nodes {
      id
      _rowTimestamp
      referenceNumber
      description
      currency {
        isoCode
      }
      companyCorporatePeriod {
        _periodYear
        startDate
        endDate
      }
      corporatePeriodId
    }
  }
}
